import classnames from "classnames"
import If from "../../../components/If"
import Loading from "./components/Loading"
import "./Button.scss"

type TVariant = "primary" | "secondary" | "high-contrast" | "action"

interface IButtonProps {
  children?: JSX.Element | string
  onClick?: () => void
  /** Caso possua valor, o botão ficará desabilitado para uso, e terá um estilo diferente. */
  disabled?: boolean
  /**
   * Estilo do botao.
   * Example uses:

   * - primary =  Serve para o cliente realizar uma ação específica onde ele pode fazer alguma alteração no mesmo fluxo ou ir para uma outra página.
   * - secondary = Botão de alto contraste, ultilizado para ter bom contraste com a cor do fundo da página.
   * - high-contrast = Serve para o cliente realizar uma ação específica onde ele pode fazer alguma alteração no mesmo fluxo ou ir para uma outra página.
   * - action = Serve para o cliente realizar uma ação específica onde ele pode fazer alguma alteração no mesmo fluxo ou ir para uma outra página.
   */
  variant?: TVariant
  /** Altera a tag HTML usada no componente. No exemplo abaixo, está sendo usado a tag a com href para o site da Red Ventures. */
  tagName?: string
  /** Concatena classes a classe padrão ds-button. */
  className?: string
  /** Recebe um componente ou string que será adicionada á esquerda do texto. No exemplo abaixo está sendo adicionado '+'. */
  leftIcon?: JSX.Element
  /** Recebe um componente ou string que será adicionada á direita do texto. No exemplo abaixo está sendo adicionado '+'. */
  rightIcon?: JSX.Element
  /** Adiciona um overlay com um SVG animado de carregamento. */
  isLoading?: boolean
  /** Faz com que o botão preencha 100% da largura do wrapper. */
  fluid?: boolean
}

const Button = ({
  children,
  disabled,
  tagName = "button",
  className = "",
  leftIcon,
  rightIcon,
  isLoading,
  variant = "primary",
  fluid,
  ...props
}: IButtonProps) => {
  const CustomTagName = tagName

  const buttonClasses = classnames("ds-button", className, {
    [`ds-button--${variant}`]: !!variant,
    "ds-button--disabled": disabled,
    "ds-button--fluid": fluid,
  })

  return (
    <CustomTagName className={buttonClasses} disabled={disabled} {...props}>
      <If
        condition={leftIcon}
        renderIf={<span className="ds-button__left-icon">{leftIcon}</span>}
      />

      {children}

      <If
        condition={rightIcon}
        renderIf={<span className="ds-button__right-icon">{rightIcon}</span>}
      />

      <If
        condition={isLoading}
        renderIf={
          <Loading
            className={classnames({
              "ds-loading--primary": variant === "primary",
              "ds-loading--high-contrast": variant === "high-contrast",
              "ds-loading--secondary": variant === "secondary",
            })}
          />
        }
      />
    </CustomTagName>
  )
}

export default Button
